import styled from "@emotion/styled";
import { FadeInContent } from "./FadeInContent";
import { Italic } from "./Italic";

const Container = styled.div`
  width: 100%;
  border-top: 1px solid #eaeaea;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 40px;
  padding: 40px;
  font-size: 14px;
  align-items: flex-start;
`;

export function Announcement() {
  return (
    <Container>
      <FadeInContent
        style={{
          textAlign: "center",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <Italic>- Announcement -</Italic>
      </FadeInContent>
      {/* <FadeInContent
        style={{
          textAlign: "center",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <b
          style={{
            fontSize: "16px",
          }}
        >
          한번 읽어봐주세요!
        </b>
      </FadeInContent> */}
      <FadeInContent
        style={{
          textAlign: "left",
        }}
      >
        <ol
          style={{
            margin: 0,
            padding: 0,
          }}
        >
          <li>
            완연한 봄날, 4월 22일 저녁 6시 30분에 예식이 시작됩니다. 그 전에 여유롭게 오셔서 인사 나누며 즐겨요!  
          </li>
          <br />
          <li>
            신부가 돌아다니는 걸 좋아해서 신부 대기실이 따로 없습니다! 신랑신부가
            직접 여러분을 맞이할게요.
          </li>
          <br />
          <li>포토부스를 준비했어요. 와주시는 분들 누구나 기념사진을 남길 수 있답니다!</li>
          <br />
          <li>격식 있는 복장 아니어도 좋아요. 편하게 놀러와주세요!</li>
          <br />
          <li>
            본식이 끝나고  바로 가면 섭섭해요. 바로 옆에서 애프터 파티를 합니다.
            신나게 놀아요! 🙂
          </li>
        </ol>
      </FadeInContent>
    </Container>
  );
}
